<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Members</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>
    <form-wrapper>
      <b-form @submit="onSubmit">
        <b-form-group>
          <label for="id">Member ID</label>
          <input
            id="id"
            :value="member.id"
            disabled
            class="form-control"
            type="text"/>
        </b-form-group>

        <b-form-group>
          <label for="id">Name</label>
          <input
            id="id"
            :value="member.user.name"
            disabled
            class="form-control"
            type="text"/>
        </b-form-group>

        <b-form-group>
          <label for="id">Email</label>
          <input
            id="id"
            :value="member.user.email"
            disabled
            class="form-control"
            type="text"/>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            :disabled="saving"
            v-model="is_active"
            value="1"
            unchecked-value="0"
            @input="setActive">
            Active
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <label for="role-input">Role</label>
          <b-form-select
            id="role-input"
            :options="roleOptions"
            :disabled="saving"
            v-model="role"
            @change="setRole"/>
        </b-form-group>

        <relate-modules
          :initial-modules="member.modules"
          :disabled="saving"
          namespace="members"/>

        <relate-groups
          :initial-groups="member.groups"
          :disabled="saving"
          namespace="members"/>

        <b-form-group class="form-buttons">
          <b-button :disabled="saving" variant="secondary" @click="$router.push({name: 'admin-members'})">
            Cancel
          </b-button>
          <b-button :disabled="disabled" type="submit" variant="primary">
            Confirm
            <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          </b-button>
        </b-form-group>

        <form-success :success="success" class="form-alert">Member Updated!</form-success>
      </b-form>
    </form-wrapper>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import page from '../../../templates/page'
import relateModules from '../modules/relateModules'
import relateGroups from '../groups/relateGroups'
import sidebar from '../../../sidebar'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    page,
    relateModules,
    relateGroups,
    sidebar,
    validationErrors
  },
  data () {
    return {
      roleOptions: [
        { text: 'user', value: 'user' },
        { text: 'admin', value: 'admin' },
        { text: 'master', value: 'master' }
      ],
      breadcrumbs: [{
        text: 'Members',
        to: { name: 'admin-members' }
      },
      {
        text: 'Edit',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('members', {
      member: 'current'
    }),
    ...mapState('members/forms/update', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    role: {
      get () {
        return this.member.role
      },
      set (newValue) {}
    },
    is_active: {
      get () {
        return this.member.is_active
      },
      set (newValue) {}
    },
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  created() {
    this.$store.commit('members/forms/update/resetState')
  },
  methods: {
    ...mapActions({
      updateMember: 'members/update'
    }),
    onSubmit (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateMember({
            memberID: this.member.id
          })
        }
      })
    },
    setActive (event) {
      this.$store.commit('members/forms/update/setField', {
        field: 'active',
        value: event
      })
    },
    setRole (event) {
      this.$store.commit('members/forms/update/setField', {
        field: 'role',
        value: event
      })
    },
    reset (event) {
      this.errors.clear()
    },
    resetFields (event) {
      this.reset()
      this.$store.commit('members/forms/update/resetFields')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/members/edit.vue